import React, { useState } from 'react';
import classNames from 'classnames';
import {
    withStyles,
    TextField,
    InputAdornment,
    IconButton,
} from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

import BrandLink from '../../../BrandLink';

const styles = theme => ({
    infoTitle: {
        fontWeight: 500,
        color: theme.palette.text.blue,
    },
    helpLink: {
        '& a': {
            textDecoration: 'none',
            color: theme.palette.text.blue,
        },
    },
    columns: {
        display: 'flex',
        '& > *': {
            paddingRight: theme.spacing(2),
        },
    },
    synchronizeButton: {
        color: '#76ab53',
        cursor: 'pointer',
    },
    synchronized: {
        cursor: 'default',
    },
});

export const Info = withStyles(styles)(({ title, text, classes }) => (
    <React.Fragment>
        <Typography component="h3" className={classes.infoTitle}>
            {title}
        </Typography>
        <Typography component="div" color="textSecondary">
            {text}
        </Typography>
    </React.Fragment>
));

export const Help = withStyles(styles)(({ title, brand, link, classes }) => (
    <div>
        <Typography component="h3">
            <strong>{title}</strong>
        </Typography>
        <Typography component="div" className={classes.helpLink}>
            <BrandLink name={brand}>{link}</BrandLink>
        </Typography>
    </div>
));

export const Columns = withStyles(styles)(({ children, classes }) => (
    <div className={classes.columns}>{children}</div>
));

export const SynchronizeButton = withStyles(styles)(
    ({ onClick, sync, classes }) => {
        const className = classNames(classes.synchronizeButton, {
            [classes.synchronized]: sync,
        });
        return (
            <Typography component="div" onClick={onClick} className={className}>
                {sync ? 'Sync in progress' : 'Sync now'}
            </Typography>
        );
    }
);

export const PasswordField = ({ error, label, value, onChange }) => {
    const [visible, setVisible] = useState(false);
    return (
        <TextField
            type={visible ? 'text' : 'password'}
            fullWidth
            error={!!error}
            margin="normal"
            variant="outlined"
            label={label}
            onChange={event => onChange(event.target.value, event)}
            helperText={error}
            value={value}
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            edge="end"
                            aria-label="toggle password visibility"
                            onClick={() => setVisible(!visible)}
                        >
                            {visible ? (
                                <VisibilityOff color="primary" />
                            ) : (
                                <Visibility color="primary" />
                            )}
                        </IconButton>
                    </InputAdornment>
                ),
            }}
        />
    );
};
